// Página pública de lance do Leilão Reverso de Frete (PO1-3083, épico
// PO1-3076). Usa o cliente anônimo: o token do link é o único controle de
// acesso, e um operador logado que abrir o link não pode mandar a própria
// sessão junto (mesma razão do convite da transportadora).
import apiPublic from "./apiPublic";

export async function contextoLeilao(token) {
  const { data } = await apiPublic.get(`/public/leilao-frete/${encodeURIComponent(token)}`);
  return data;
}

// { aceitarAlvo: true, prazoDias } ou { valor, prazoDias }
export async function enviarLance(token, dados) {
  const { data } = await apiPublic.post(`/public/leilao-frete/${encodeURIComponent(token)}/lance`, dados);
  return data;
}

export async function recusarLeilao(token, { motivo } = {}) {
  const { data } = await apiPublic.post(`/public/leilao-frete/${encodeURIComponent(token)}/recusar`, { motivo });
  return data;
}
